/**
 * Export cheerio (with )
 */

exports = module.exports = require('./lib/cheerio');

/*
  Export the version
*/

exports.version = require('./package.json').version;



//////////////////
// WEBPACK FOOTER
// ./~/cheerio/index.js
// module id = 269
// module chunks = 0